import { Theme } from '@emotion/react';

const getThemeClasses: (theme: Theme) => string = (
  theme
) => `
  /* general theme props */
  .theme--button-border-radius {
    border-radius: ${theme.buttonBorderRadius}px;
  }
  
  .theme--thumbnail-border-radius {
    border-radius: ${theme.thumbnailBorderRadius}px;
  }
  
  /* regular theme colors */
  .theme--primary-color {
    color: ${theme.primaryColor};
    fill: ${theme.primaryColor};
    
    &:hover {
      color: ${theme.primaryColor};
      fill: ${theme.primaryColor};
    }

    &:focus {
      color: ${theme.primaryColor};
      fill: ${theme.primaryColor};
    }
    
    &:active {
      color: ${theme.primaryColor};
      fill: ${theme.primaryColor};
    }

    &:visited {
      color: ${theme.primaryColor};
      fill: ${theme.primaryColor};
    }
  }
  
  .theme--secondary-color {
    color: ${theme.secondaryColor};
    fill: ${theme.secondaryColor};
    
    &:hover {
      color: ${theme.secondaryColor};
      fill: ${theme.secondaryColor};
    }

    &:focus {
      color: ${theme.secondaryColor};
      fill: ${theme.secondaryColor};
    }
    
    &:active {
      color: ${theme.secondaryColor};
      fill: ${theme.secondaryColor};
    }

    &:visited {
      color: ${theme.secondaryColor};
      fill: ${theme.secondaryColor};
    }
  }

  .theme--highlight-color {
    color: ${theme.highlightColor};
    fill: ${theme.highlightColor};
    
    &:hover {
      color: ${theme.highlightColor};
      fill: ${theme.highlightColor};
    }

    &:focus {
      color: ${theme.highlightColor};
      fill: ${theme.highlightColor};
    }
    
    &:active {
      color: ${theme.highlightColor};
      fill: ${theme.highlightColor};
    }

    &:visited {
      color: ${theme.highlightColor};
      fill: ${theme.highlightColor};
    }
  }
  
  .theme--primary-font-color {
    color: ${theme.primaryFontColor};
    fill: ${theme.primaryFontColor};
    
    &:hover {
      color: ${theme.primaryFontColor};
      fill: ${theme.primaryFontColor};
    }

    &:focus {
      color: ${theme.primaryFontColor};
      fill: ${theme.primaryFontColor};
    }
    
    &:active {
      color: ${theme.primaryFontColor};
      fill: ${theme.primaryFontColor};
    }

    &:visited {
      color: ${theme.primaryFontColor};
      fill: ${theme.primaryFontColor};
    }
  }
  
  .theme--secondary-font-color {
    color: ${theme.secondaryFontColor};
    fill: ${theme.secondaryFontColor};
    
    &:hover {
      color: ${theme.secondaryFontColor};
      fill: ${theme.secondaryFontColor};
    }

    &:focus {
      color: ${theme.secondaryFontColor};
      fill: ${theme.secondaryFontColor};
    }
    
    &:active {
      color: ${theme.secondaryFontColor};
      fill: ${theme.secondaryFontColor};
    }

    &:visited {
      color: ${theme.secondaryFontColor};
      fill: ${theme.secondaryFontColor};
    }
  }

  .theme--background-color {
    color: ${theme.backgroundColor};
    fill: ${theme.backgroundColor};
    
    &:hover {
      color: ${theme.backgroundColor};
      fill: ${theme.backgroundColor};
    }

    &:focus {
      color: ${theme.backgroundColor};
      fill: ${theme.backgroundColor};
    }
    
    &:active {
      color: ${theme.backgroundColor};
      fill: ${theme.backgroundColor};
    }

    &:visited {
      color: ${theme.backgroundColor};
      fill: ${theme.backgroundColor};
    }
  }

  .theme--disabled-font-color {
    color: ${theme.disabledFontColor};
    fill: ${theme.disabledFontColor};
    
    &:hover {
      color: ${theme.disabledFontColor};
      fill: ${theme.disabledFontColor};
    }

    &:focus {
      color: ${theme.disabledFontColor};
      fill: ${theme.disabledFontColor};
    }
    
    &:active {
      color: ${theme.disabledFontColor};
      fill: ${theme.disabledFontColor};
    }

    &:visited {
      color: ${theme.disabledFontColor};
      fill: ${theme.disabledFontColor};
    }
  }
  
  .theme--card-color {
    color: ${theme.cardColor};
    fill: ${theme.cardColor};
    
    &:hover {
      color: ${theme.cardColor};
      fill: ${theme.cardColor};
    }

    &:focus {
      color: ${theme.cardColor};
      fill: ${theme.cardColor};
    }
    
    &:active {
      color: ${theme.cardColor};
      fill: ${theme.cardColor};
    }

    &:visited {
      color: ${theme.cardColor};
      fill: ${theme.cardColor};
    }
  }

  .theme--border-color {
    color: ${theme.borderColor};
    fill: ${theme.borderColor};
    
    &:hover {
      color: ${theme.borderColor};
      fill: ${theme.borderColor};
    }

    &:focus {
      color: ${theme.borderColor};
      fill: ${theme.borderColor};
    }
    
    &:active {
      color: ${theme.borderColor};
      fill: ${theme.borderColor};
    }

    &:visited {
      color: ${theme.borderColor};
      fill: ${theme.borderColor};
    }
  }
 
  .theme--disabled-background-color {
    color: ${theme.disabledBackgroundColor};
    fill: ${theme.disabledBackgroundColor};
    
    &:hover {
      color: ${theme.disabledBackgroundColor};
      fill: ${theme.disabledBackgroundColor};
    }

    &:focus {
      color: ${theme.disabledBackgroundColor};
      fill: ${theme.disabledBackgroundColor};
    }
    
    &:active {
      color: ${theme.disabledBackgroundColor};
      fill: ${theme.disabledBackgroundColor};
    }

    &:visited {
      color: ${theme.disabledBackgroundColor};
      fill: ${theme.disabledBackgroundColor};
    }
  }

  .theme--success-color {
    color: ${theme.successColor};
    fill: ${theme.successColor};
    
    &:hover {
      color: ${theme.successColor};
      fill: ${theme.successColor};
    }

    &:focus {
      color: ${theme.successColor};
      fill: ${theme.successColor};
    }
    
    &:active {
      color: ${theme.successColor};
      fill: ${theme.successColor};
    }

    &:visited {
      color: ${theme.successColor};
      fill: ${theme.successColor};
    }
  }

  .theme--error-color {
    color: ${theme.errorColor};
    fill: ${theme.errorColor};
    
    &:hover {
      color: ${theme.errorColor};
      fill: ${theme.errorColor};
    }

    &:focus {
      color: ${theme.errorColor};
      fill: ${theme.errorColor};
    }
    
    &:active {
      color: ${theme.errorColor};
      fill: ${theme.errorColor};
    }

    &:visited {
      color: ${theme.errorColor};
      fill: ${theme.errorColor};
    }
  }
 
  .theme--overlay-color {
    color: ${theme.overlayColor};
    fill: ${theme.overlayColor};
    
    &:hover {
      color: ${theme.overlayColor};
      fill: ${theme.overlayColor};
    }

    &:focus {
      color: ${theme.overlayColor};
      fill: ${theme.overlayColor};
    }
    
    &:active {
      color: ${theme.overlayColor};
      fill: ${theme.overlayColor};
    }

    &:visited {
      color: ${theme.overlayColor};
      fill: ${theme.overlayColor};
    }
  }

  /* background colors */
  .theme--bg-primary-color {
    background-color: ${theme.primaryColor};
  }

  .theme--bg-secondary-color {
    background-color: ${theme.secondaryColor};
  }

  .theme--bg-highlight-color {
    background-color: ${theme.highlightColor};
  }

  .theme--bg-primary-font-color {
    background-color: ${theme.primaryFontColor};
  }

  .theme--bg-secondary-font-color {
    background-color: ${theme.secondaryFontColor};
  }
  
  .theme--bg-background-color {
    background-color: ${theme.backgroundColor};
  }
  
  .theme--bg-disabled-font-color {
    background-color: ${theme.disabledFontColor};
  }

  .theme--bg-card-color {
    background-color: ${theme.cardColor};
  }
  
  .theme--bg-border-color {
    background-color: ${theme.borderColor};
  }

  .theme--bg-disabled-background-color {
    background-color: ${theme.disabledBackgroundColor};
  }

  .theme--bg-success-color {
    background-color: ${theme.successColor};
  }

  .theme--bg-error-color {
    background-color: ${theme.errorColor};
  }
  
  .theme--bg-overlay-color {
    background-color: ${theme.overlayColor};
  }
  
  /* stateful colors */
  .theme--hover-primary-color:hover {
    color: ${theme.primaryColor};
    fill: ${theme.primaryColor};
  }
  
  .theme--active-primary-color:active {
    color: ${theme.primaryColor};
    fill: ${theme.primaryColor};
  }
  
  .theme--focus-primary-color:focus {
    color: ${theme.primaryColor};
    fill: ${theme.primaryColor};
  }

  .theme--hover-secondary-color:hover {
    color: ${theme.secondaryColor};
    fill: ${theme.secondaryColor};
  }
  
  .theme--active-secondary-color:active {
    color: ${theme.secondaryColor};
    fill: ${theme.secondaryColor};
  }
  
  .theme--focus-secondary-color:focus {
    color: ${theme.secondaryColor};
    fill: ${theme.secondaryColor};
  }
  
  .theme--hover-highlight-color:hover {
    color: ${theme.highlightColor};
    fill: ${theme.highlightColor};
  }
  
  .theme--active-highlight-color:active {
    color: ${theme.highlightColor};
    fill: ${theme.highlightColor};
  }
  
  .theme--focus-highlight-color:focus {
    color: ${theme.highlightColor};
    fill: ${theme.highlightColor};
  }

  .theme--hover-primary-font-color:hover {
    color: ${theme.primaryFontColor};
    fill: ${theme.primaryFontColor};
  }
  
  .theme--active-primary-font-color:active {
    color: ${theme.primaryFontColor};
    fill: ${theme.primaryFontColor};
  }
  
  .theme--focus-primary-font-color:focus {
    color: ${theme.primaryFontColor};
    fill: ${theme.primaryFontColor};
  }

  .theme--hover-secondary-font-color:hover {
    color: ${theme.secondaryFontColor};
    fill: ${theme.secondaryFontColor};
  }
  
  .theme--active-secondary-font-color:active {
    color: ${theme.secondaryFontColor};
    fill: ${theme.secondaryFontColor};
  }
  
  .theme--focus-secondary-font-color:focus {
    color: ${theme.secondaryFontColor};
    fill: ${theme.secondaryFontColor};
  }

  .theme--hover-background-color:hover {
    color: ${theme.backgroundColor};
    fill: ${theme.backgroundColor};
  }
  
  .theme--active-background-color:active {
    color: ${theme.backgroundColor};
    fill: ${theme.backgroundColor};
  }
  
  .theme--focus-background-color:focus {
    color: ${theme.backgroundColor};
    fill: ${theme.backgroundColor};
  }
 
  .theme--hover-disabled-font-color:hover {
    color: ${theme.disabledFontColor};
    fill: ${theme.disabledFontColor};
  }
  
  .theme--active-disabled-font-color:active {
    color: ${theme.disabledFontColor};
    fill: ${theme.disabledFontColor};
  }
  
  .theme--focus-disabled-font-color:focus {
    color: ${theme.disabledFontColor};
    fill: ${theme.disabledFontColor};
  }

  .theme--hover-card-color:hover {
    color: ${theme.cardColor};
    fill: ${theme.cardColor};
  }
  
  .theme--active-card-color:active {
    color: ${theme.cardColor};
    fill: ${theme.cardColor};
  }
  
  .theme--focus-card-color:focus {
    color: ${theme.cardColor};
    fill: ${theme.cardColor};
  }

  .theme--hover-border-color:hover {
    color: ${theme.borderColor};
    fill: ${theme.borderColor};
  }
  
  .theme--active-border-color:active {
    color: ${theme.borderColor};
    fill: ${theme.borderColor};
  }
  
  .theme--focus-border-color:focus {
    color: ${theme.borderColor};
    fill: ${theme.borderColor};
  }

  .theme--hover-disabled-background-color:hover {
    color: ${theme.disabledBackgroundColor};
    fill: ${theme.disabledBackgroundColor};
  }
  
  .theme--active-disabled-background-color:active {
    color: ${theme.disabledBackgroundColor};
    fill: ${theme.disabledBackgroundColor};
  }
  
  .theme--focus-disabled-background-color:focus {
    color: ${theme.disabledBackgroundColor};
    fill: ${theme.disabledBackgroundColor};
  }  
  
  .theme--hover-success-color:hover {
    color: ${theme.successColor};
    fill: ${theme.successColor};
  }
  
  .theme--active-success-color:active {
    color: ${theme.successColor};
    fill: ${theme.successColor};
  }
  
  .theme--focus-success-color:focus {
    color: ${theme.successColor};
    fill: ${theme.successColor};
  }  
  
  .theme--hover-error-color:hover {
    color: ${theme.errorColor};
    fill: ${theme.errorColor};
  }
  
  .theme--active-error-color:active {
    color: ${theme.errorColor};
    fill: ${theme.errorColor};
  }
  
  .theme--focus-error-color:focus {
    color: ${theme.errorColor};
    fill: ${theme.errorColor};
  }  
  
  .theme--hover-overlay-color:hover {
    color: ${theme.overlayColor};
    fill: ${theme.overlayColor};
  }
  
  .theme--active-overlay-color:active {
    color: ${theme.overlayColor};
    fill: ${theme.overlayColor};
  }
  
  .theme--focus-overlay-color:focus {
    color: ${theme.overlayColor};
    fill: ${theme.overlayColor};
  }  
  
  /* stateful background colors */
  .theme--bg-hover-primary-color:hover {
    background-color: ${theme.primaryColor};
  }
  
  .theme--bg-hover-secondary-color:hover {
    background-color: ${theme.secondaryColor};
  }
  
  .theme--bg-hover-highlight-color:hover {
    background-color: ${theme.highlightColor};
  }

  .theme--bg-hover-primary-font-color:hover {
    background-color: ${theme.primaryFontColor};
  }

  .theme--bg-hover-secondary-font-color:hover {
    background-color: ${theme.secondaryFontColor};
  }  

  .theme--bg-hover-background-color:hover {
    background-color: ${theme.backgroundColor};
  }
  
  .theme--bg-hover-disabled-font-color:hover {
    background-color: ${theme.disabledFontColor};
  }

  .theme--bg-hover-card-color:hover {
    background-color: ${theme.cardColor};
  }

  .theme--bg-hover-border-color:hover {
    background-color: ${theme.borderColor};
  }

  .theme--bg-hover-disabled-background-color:hover {
    background-color: ${theme.disabledBackgroundColor};
  }

  .theme--bg-hover-success-color:hover {
    background-color: ${theme.successColor};
  }
  
  .theme--bg-hover-error-color:hover {
    background-color: ${theme.errorColor};
  }
  
  .theme--bg-hover-overlay-color:hover {
    background-color: ${theme.overlayColor};
  }
`;

export default getThemeClasses;
